// Allow form radio buttons to be deselected.

// The HTML we're dealing with: 
// (at time of writing, this is generated in just one place: DynamicForm.cshtml line #104):
//
// <span class="radio-item">
//   <input type="radio">
//   <label>...</label>
// </span>
//
// <input> is invisible, stores the current on/off value.
// <label> is the visible clickable bit.

;(function () {
    var radioItems = document.querySelectorAll('.radio-item');      // Find all <span class="radio-item"> wrapper items.
    for (i=0; i<radioItems.length; i++) {                           // Loop through each radio option.
        var item = radioItems[i];                                   // Find the current wrapper item.
        var label = item.querySelector('label');                    // Find the clickable label.
        label.addEventListener("click", function(e) {               // When the label is clicked,
            e.preventDefault();                                     // stop the browser from selecting the input.
            var input = this.parentElement.querySelector('input');  // Find the radio input inside the current wrapper item,
            input.checked = !input.checked;                         // and toggle its status.
        });
    }
})();

// An alternate method for clearing radio buttons:
// This function can be called from a button on the page
// ie. onclick="clearRadioButtons(this)"
function clearRadioButtons(el) {
    var fieldset = el.parentNode;                                   // Contains the current set of radio inputs.
    var radios = fieldset.querySelectorAll('input');                // All radios in the current set.
    for (i=0; i<radios.length; i++) {                               // Loop through each radio input,
        radios[i].checked = false;                                  // and set it to false.
    };
};